var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { "pl-4": "" } },
    [
      _vm.loading
        ? _c(
            "v-layout",
            { attrs: { column: "" } },
            [
              _c(
                "v-flex",
                { staticClass: "text-md-center py-3" },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", color: "primary" }
                  })
                ],
                1
              )
            ],
            1
          )
        : [
            _c(
              "v-layout",
              { attrs: { "pt-2": "", "px-4": "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { xs6: "" } },
                  [
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-list",
                          [
                            _c(
                              "v-list-tile",
                              [
                                _c(
                                  "v-list-tile-content",
                                  [
                                    _c("v-list-tile-title", [
                                      _c("b", [_vm._v(_vm._s(_vm.user.name))]),
                                      _vm._v(" "),
                                      _c("i", [
                                        _vm._v("(" + _vm._s(_vm.user.id) + ")")
                                      ])
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile",
                              [
                                _c(
                                  "v-list-tile-content",
                                  [
                                    _c("v-list-tile-title", [
                                      _vm._v("Contact Phone")
                                    ]),
                                    _vm._v(" "),
                                    _c("v-list-tile-sub-title", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.user.contactPhone) +
                                          "\n                "
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile",
                              [
                                _c(
                                  "v-list-tile-content",
                                  [
                                    _c("v-list-tile-title", [
                                      _vm._v("Brief Bio")
                                    ]),
                                    _vm._v(" "),
                                    _c("v-list-tile-sub-title", [
                                      _vm._v(_vm._s(_vm.user.briefBio))
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.user.driverProfile
                              ? _c(
                                  "v-list-tile",
                                  [
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c("v-list-tile-title", [
                                          _vm._v("CDL Expires:")
                                        ]),
                                        _vm._v(" "),
                                        _c("v-list-tile-sub-title", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm._f("formatDate")(
                                                  _vm.user.driverProfile
                                                    .cdlExpires
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.user.driverProfile
                              ? _c(
                                  "v-list-tile",
                                  [
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c("v-list-tile-title", [
                                          _vm._v("Medical Expires:")
                                        ]),
                                        _vm._v(" "),
                                        _c("v-list-tile-sub-title", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm._f("formatDate")(
                                                  _vm.user.driverProfile
                                                    .medicalExpires
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { xs6: "" } },
                  [
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-layout",
                          { staticClass: "mt-3", attrs: { column: "" } },
                          [
                            _c(
                              "v-layout",
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "secondary--text",
                                    attrs: { sm2: "" }
                                  },
                                  [_vm._v("Company")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "secondary--text",
                                    attrs: { sm2: "" }
                                  },
                                  [_vm._v("Phone")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "secondary--text",
                                    attrs: { sm2: "" }
                                  },
                                  [_vm._v("Email")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "secondary--text",
                                    attrs: { sm3: "" }
                                  },
                                  [_vm._v("Permissions")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-divider", { staticClass: "my-1" }),
                            _vm._v(" "),
                            _vm._l(_vm.user.companyAccounts, function(
                              companyAccount,
                              index
                            ) {
                              return [
                                _c(
                                  "v-layout",
                                  { key: index },
                                  [
                                    _c("v-flex", { attrs: { sm2: "" } }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            companyAccount.companyDisplayName
                                          )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("v-flex", { attrs: { sm3: "" } }, [
                                      _vm._v(
                                        _vm._s(companyAccount.contactPhone) +
                                          " "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("v-flex", { attrs: { sm3: "" } }, [
                                      _vm._v(
                                        _vm._s(companyAccount.contactEmail) +
                                          " "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("v-flex", { attrs: { sm3: "" } }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            companyAccount.companyPermissions
                                              ? companyAccount.companyPermissions.join(
                                                  ", "
                                                )
                                              : null
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-divider", {
                                  key: "div_" + index,
                                  staticClass: "my-1"
                                })
                              ]
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("notification-settings", {
              attrs: { expandVersion: "", "user-id": _vm.user.id }
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-024fe1f5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-024fe1f5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserExpand.vue
// module id = null
// module chunks = 